/* eslint-disable max-len */

import { ICoinPageData } from '../types'

export const usdttrc20Page: ICoinPageData = {
  title: 'coin_1048',
  description: 'coin_1049',
  // description:
  //   'Get a USDT TRC 20 loan with CoinRabbit. Borrow against crypto for an unlimited term without credit checks. Receive up to 90% of your collateral in cash or crypto and continue holding. Get funds without selling crypto in 15 minutes.',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'USDT (TRC20)' }) }}
    />
  ),
  questionsBlock: {
    questions: [
      {
        title: 'coin_1050',
        answer: 'coin_1051',
      },
      {
        title: 'coin_1052',
        answer: 'coin_1053',
      },
      {
        title: 'coin_1054',
        answer: 'coin_1055',
      },
      {
        title: 'coin_1056',
        answer: 'coin_1057',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_1058',
        text: ['coin_1062'],
      },
      {
        title: 'coin_1059',
        text: ['coin_1063'],
      },
      {
        title: 'coin_1060',
        text: ['coin_1064', 'coin_1065', 'coin_1066', 'coin_1067', 'coin_1068'],
      },
      {
        title: 'coin_1061',
        text: ['coin_1069', 'coin_1070', 'coin_1071', 'coin_1072', 'coin_1073'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'USDT crypto review 1',
      },
      {
        link: 'https://coinrabbit.io/blog/coinrabbit-earnings-interest-review/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/integration-7CR_EARN1.png',
        imageAlt: 'USDT crypto review 2',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'USDT crypto review 3',
      },
    ],
  },
}
